import React from "react";

import * as Styled from "./DetailsPane.styles";

interface DetailsPaneNudge {
  children: React.ReactNode;
}

const DetailsPaneNudge = ({ children }: DetailsPaneNudge): JSX.Element => {
  return <Styled.DetailsPaneSection>{children}</Styled.DetailsPaneSection>;
};

export { DetailsPaneNudge };
